import React from 'react';
import { Prompt } from 'react-router';
import PropTypes from 'prop-types';
import { Button, ThemeProvider } from '@knockrentals/knock-shared-web';
import ConfirmationDialog from '../../Features/common/ConfirmationDialog';
import AffordableCard from './AffordableCard';
import AffordableDetails from './AffordableDetails';
import { AffordableIncomeEligibility } from './AffordableIncomeEligibility';
import { useAffordable } from './use-affordable';
import { PAGE_NAVIGATION_PROMPT_VIEWS } from '../../../constants';
import {
  AFFORDABLE_DETAILS,
  CONFIRMATION_BUTTON_TEXT,
  CONFIRMATION_MESSAGES,
  CONFIRMATION_SECONDARY_BUTTON_TEXT,
  CONFIRMATION_TITLES,
  INCOME_ELIGIBILITY,
} from './constants';
import './_Affordable.scss';

export const AffordableTab = ({ affordable = {}, saveAffordable }) => {
  const {
    clearIncomeEligibilityValidationErrorMessage,
    closeConfirmationDialog,
    confirmationMode,
    confirmationSecondaryButtonAction,
    deleteEligibleQualification,
    details,
    detailsValidationErrorMessage,
    handleConfirmation,
    handleUpdateOnClick,
    incomeEligibility,
    isUpdateDisabled,
    setDetails,
    setDetailsValidationErrorMessage,
    setIncomeEligibility,
    updateEligibleQualification,
  } = useAffordable({ affordable, saveAffordable });

  return (
    <ThemeProvider>
      <Prompt
        message={PAGE_NAVIGATION_PROMPT_VIEWS.AFFORDABLE}
        when={!isUpdateDisabled}
      />

      <section className="affordable-tab">
        <ConfirmationDialog
          closeDialog={closeConfirmationDialog}
          handleConfirmation={handleConfirmation}
          isOpen={Boolean(confirmationMode)}
          message={CONFIRMATION_MESSAGES[confirmationMode]}
          primaryButtonText={CONFIRMATION_BUTTON_TEXT[confirmationMode]}
          secondaryButtonAction={confirmationSecondaryButtonAction}
          secondaryButtonText={
            CONFIRMATION_SECONDARY_BUTTON_TEXT[confirmationMode]
          }
          title={CONFIRMATION_TITLES[confirmationMode]}
        />

        <div className="affordable-update">
          <Button disabled={isUpdateDisabled} onClick={handleUpdateOnClick}>
            Update
          </Button>
        </div>

        <AffordableCard
          subtitle={AFFORDABLE_DETAILS.SUBTITLE}
          title={AFFORDABLE_DETAILS.TITLE}
        >
          <AffordableDetails
            details={details}
            errorMessage={detailsValidationErrorMessage}
            setDetails={setDetails}
            setDetailsValidationErrorMessage={setDetailsValidationErrorMessage}
          />
        </AffordableCard>

        <AffordableCard
          subtitle={INCOME_ELIGIBILITY.SUBTITLE}
          title={INCOME_ELIGIBILITY.TITLE}
        >
          <AffordableIncomeEligibility
            clearValidationErrorMessage={
              clearIncomeEligibilityValidationErrorMessage
            }
            deleteEligibleQualification={deleteEligibleQualification}
            incomeEligibility={incomeEligibility}
            setIncomeEligibility={setIncomeEligibility}
            updateEligibleQualification={updateEligibleQualification}
          />
        </AffordableCard>
      </section>
    </ThemeProvider>
  );
};

AffordableTab.propTypes = {
  affordable: PropTypes.shape({
    details: PropTypes.string,
    income_eligibility: PropTypes.arrayOf(
      PropTypes.shape({
        maximum_income: PropTypes.string,
        occupants: PropTypes.string,
      })
    ),
  }),
  saveAffordable: PropTypes.func,
};

export default AffordableTab;
